import { useTranslation } from "react-i18next";

import { Badge } from "@/components/ui/badge";
import type { BadgeVariant } from "@/components/ui/badge/badge.variants";
import { ENUM_COMAPNY_POLICIES_STATUS } from "@/utils/enums/company-policies.enum";

// One map for every policy status pill in this feature — the list, the summary
// view and the creation form each carried their own copy, hardcoded to raw
// Tailwind palette values (`bg-green-100`, `bg-red-200`, …) that ignore the
// theme tokens and drifted apart (the list's fallback was yellow, the form's
// orange). Semantic `Badge` variants keep them in sync and on-token.
//
// `labelKey` is a translation key, not a label: this map sits at module scope,
// so a literal would freeze at import time and survive a language switch.
const POLICY_STATUS: Record<
  ENUM_COMAPNY_POLICIES_STATUS,
  { labelKey: string; variant: BadgeVariant }
> = {
  [ENUM_COMAPNY_POLICIES_STATUS.PUBLISHED]: {
    labelKey: "common:status.published",
    variant: "success",
  },
  [ENUM_COMAPNY_POLICIES_STATUS.DRAFT]: {
    labelKey: "common:status.draft",
    variant: "warning",
  },
  [ENUM_COMAPNY_POLICIES_STATUS.WITHDRAWN]: {
    labelKey: "common:status.withdrawn",
    variant: "danger",
  },
};

interface IProps {
  status?: ENUM_COMAPNY_POLICIES_STATUS | null;
  className?: string;
}

export const PolicyStatusBadge = ({ status, className }: IProps) => {
  const { t } = useTranslation("common");
  const entry = status ? POLICY_STATUS[status] : undefined;
  return (
    <Badge variant={entry?.variant ?? "neutral"} className={className}>
      {t(entry?.labelKey ?? "common:status.unknown")}
    </Badge>
  );
};
